import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { submitEmployeeAccount } from '../../../../services/request';
import { useAccounts } from '../Context';
import AddIcon from '@mui/icons-material/Add';
import AddAccountForm from './CreateAccountForm';


export default function AddAccountModal() {
  const { rows } = useAccounts();
  const [open, setOpen] = useState(false);

  return <Box
    sx={{ p: 3, width: '100%',
      display: 'flex',
      flexDirection: 'row' }}>
    <Button fullWidth variant = "contained" endIcon={<AddIcon />} onClick={() => setOpen(true)}>Dodaj użytkownika</Button>
    {open ? <AddAccountForm rows={rows} createAccount={submitEmployeeAccount} setOpen={setOpen} /> : null}
  </Box>;
}
